import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UiService {
  private spinnerSubject$ = new BehaviorSubject<boolean>(null);

  spinnerSubject() {
    return this.spinnerSubject$.asObservable();
  }

  emitSpinnerSubject(val) {
    this.spinnerSubject$.next(val);
  }

  spiltUrlParams(url: any) {
    const splitUrl = url.split('/');
    if (!isNaN(splitUrl[splitUrl.length - 1])) {
      return url.slice(0, url.lastIndexOf('/'));
    } else {
      return url;
    }
  }
}
